import moment from 'jalali-moment'
import dayjs from 'dayjs'
import toFaNumber from './number'

export function getJalaliDate(date) {
    if (!date) {
        return ''
    }
    return moment(date.toString()).format('jYYYY/jMM/jDD')
}


export function getJalaliDateTime(date) {
    if (!date) {
        return ''
    }
    return moment(date.toString()).format('HH:mm - jYYYY/jMM/jDD ')
}

export function formatDateFull(iso) {
    const d = new Date(iso);
    return d.toLocaleDateString('fa-IR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}


export function getJalaliDateString(date) {
    if (!date) {
        return ''
    }
    return moment(date.toString()).format('jDD jMMMM jYYYY')
}


// datepicker
export function convertToServerDate(date) {
    if (!date) {
        return ''
    }
    return moment(date.toString()).format('YYYY-MM-DD')
}

export function convertToServerDateTime(date) {
    if (!date) {
        return ''
    }
    return moment(date.toString()).format('YYYY-MM-DD HH:mm:ss')
}

export function convertToDayJS(date) {
    if (date && date.isValid) {
        return date
    }
    return dayjs(date.toString(), {jalali: true})
}

export function convertToJalaliWithFormat(date, format = 'jYYYY/jMM/jDD', showPersianNumbers = true) {
    if (!date) {
        return ''
    }

    const jalaliDate = moment(date.toString()).format(format)

    if (showPersianNumbers) {
        // Convert numbers to Persian
        return jalaliDate.replace(/\d+/g, (match) => toFaNumber(match))
    }

    return jalaliDate
}
